import React from "react";

import { IPanelProps, Panel } from "core/decorators/Panel";
import { CategoryEdit } from "./category/CategoryEdit";
import CategoryDetailsPanelConfig from "./config/CategoryDetailsPanelConfig";
import constants from "./constants";

@Panel({
	id: "kb-category-details",
	configClass: CategoryDetailsPanelConfig,
	pageParams: true
})
class CategoryDetailsPanel extends React.Component<IPanelProps<CategoryDetailsPanelConfig>> {

	public render() {
		const { config, pageParams } = this.props;

		// using a key to trigger full refresh when category changes
		const key = (
			pageParams[constants.PARAM_CATEGORY_ID] ||
			pageParams[constants.PARAM_CATEGORY_GUID] ||
			config.categoryGuid
		);

		return (
			<CategoryEdit
				key={key}
				categoryId={pageParams[constants.PARAM_CATEGORY_ID]}
				guid={pageParams[constants.PARAM_CATEGORY_GUID] || config.categoryGuid}
			/>
		);
	}
}



// WEBPACK FOOTER //
// ./src/panels/kb/Category.panel.tsx